<template>
	<div>
		<table>
			<thead>
				<tr class="body-text-1">
					<th class="th-question__email" @click="sortColumn('email')">
						<div class="th-sort">
							<span> {{ $t('email') }} </span>
							<span v-if="sortedColumn === 'email'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th class="th-question__names" @click="sortColumn('firstName')">
						<div class="th-sort">
							<span> {{ $t('firstName') }}</span>
							<span v-if="sortedColumn === 'firstName'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th class="th-question__names" @click="sortColumn('lastName')">
						<div class="th-sort">
							<span> {{ $t('lastName') }}</span>
							<span v-if="sortedColumn === 'lastName'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th
						class="th-question__role"
						@click="sortColumn('cmsRole.role_Name')"
					>
						<div class="th-sort">
							<span> {{ $t('roleName') }}</span>
							<span v-if="sortedColumn === 'cmsRole.role_Name'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th
						class="th-question__names"
						@click="sortColumn('userFacilities.name')"
					>
						<div class="th-sort">
							<span> {{ $t('facility') }} </span>
							<span v-if="sortedColumn === 'userFacilities.name'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th class="th-question__actions">{{ $t('actions') }}</th>
				</tr>
			</thead>
			<tbody class="body-text-2">
				<tr class="search-row">
					<td class="td-input">
						<label class="custom-input">
							<svgicon name="search"> </svgicon>
							<input v-model="searchEmail" />
						</label>
					</td>
					<td class="td-input">
						<label class="custom-input">
							<svgicon name="search"> </svgicon>
							<input v-model="searchFirstName" />
						</label>
					</td>
					<td class="td-input">
						<label class="custom-input">
							<svgicon name="search"> </svgicon>
							<input v-model="searchLastName" />
						</label>
					</td>
					<td class="td-input">
						<label class="custom-input">
							<svgicon name="search"> </svgicon>
							<input v-model="searchRoleName" />
						</label>
					</td>
					<td class="td-input">
						<label class="custom-input">
							<svgicon name="search"> </svgicon>
							<input v-model="searchFacility" />
						</label>
					</td>
					<td></td>
				</tr>
				<tr
					v-for="(row, index) in displayedData"
					:key="index"
					class="table-row"
				>
					<td class="description-cell">{{ row.email }}</td>
					<td>{{ row.firstName }}</td>
					<td>{{ row.lastName }}</td>
					<td class="description-cell">{{ row.cmsRole.role_Name }}</td>
					<td class="description-cell">
						{{ row.userFacilities[0].name }}
					</td>
					<td class="td-center">
						<button class="action-button" @click="editRow(row)">
							<svgicon
								v-if="isSuperAdmin || isUSAAdmin"
								name="pencil"
							></svgicon>
							<svgicon
								v-if="!(isSuperAdmin || isUSAAdmin)"
								name="search"
							></svgicon>
						</button>
						<button
							v-if="isSuperAdmin || isUSAAdmin"
							class="action-button"
							@click="openDeleteModal(row)"
						>
							<svgicon name="trash"></svgicon>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		<ja-pagination
			:current="currentPage"
			:data-per-page="itemsPerPage"
			:data-count="filteredData.length"
			@changePage="setAllPage"
		></ja-pagination>
		<ja-confirm-modal
			:show="showMessageDeletionModal"
			:title="$t('confirmation')"
			:confirm-text="$t('yes')"
			:cancel-text="$t('no')"
			class="confirm-modal--medium"
			@confirm="deleteFacility()"
			@closeModal="closeMessageDeletionModal()"
			@cancel="closeMessageDeletionModal()"
		>
			<h3 class="body-text-2">
				{{
					$t('deleteMessageCms', {
						title: titleDelete
					})
				}}
			</h3>
		</ja-confirm-modal>
	</div>
</template>
<script>
import Pagination from '@/components/AdminSection/elements/Pagination';
import ConfirmModal from '@/components/Modal/ConfirmModal.vue';
import AdminFacility from '@/mixins/AdminFacility';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';
import '@/components/icons/cms/arrowDown';
import '@/components/icons/cms/arrowUp';

export default {
	components: {
		jaConfirmModal: ConfirmModal,
		jaPagination: Pagination
	},
	mixins: [AdminFacility],
	props: {
		data: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			showMessageDeletionModal: false,
			sortedColumn: null,
			sortOrder: 1,
			isSorted: false,
			currentPage: 1,
			itemsPerPage: 150,
			searchEmail: '',
			searchFirstName: '',
			searchLastName: '',
			searchRoleName: '',
			searchFacility: '',
			rowToDelete: null,
			titleDelete: 'record'
		};
	},
	computed: {
		filteredData() {
			let filteredData = this.data.filter(row => {
				let firstNameMatch = false;
				let lastNameMatch = false;

				if (this.searchFirstName.length > 0 || this.searchLastName.length > 0) {
					firstNameMatch = row.firstName
						? row.firstName
								.toLowerCase()
								.includes(this.searchFirstName.toLowerCase())
						: false;
					lastNameMatch = row.lastName
						? row.lastName
								.toLowerCase()
								.includes(this.searchLastName.toLowerCase())
						: false;
				} else {
					firstNameMatch =
						!row.firstName ||
						row.firstName
							.toLowerCase()
							.includes(this.searchFirstName.toLowerCase());
					lastNameMatch =
						!row.lastName ||
						row.lastName
							.toLowerCase()
							.includes(this.searchLastName.toLowerCase());
				}

				return (
					row.email.toLowerCase().includes(this.searchEmail) &&
					firstNameMatch &&
					lastNameMatch &&
					row.cmsRole.role_Name
						.toLowerCase()
						.includes(this.searchRoleName.toLowerCase()) &&
					row.userFacilities[0].name
						.toLowerCase()
						.includes(this.searchFacility.toLowerCase())
				);
			});

			if (this.sortedColumn) {
				filteredData = filteredData.sort((a, b) => {
					if (this.sortedColumn.includes('.')) {
						const keys = this.sortedColumn.split('.');
						let fieldA = a;
						let fieldB = b;
						for (const key of keys) {
							fieldA = fieldA[key];
							fieldB = fieldB[key];
						}
						return (fieldA > fieldB ? -1 : 1) * this.sortOrder;
					} else {
						const fieldA = a[this.sortedColumn];
						const fieldB = b[this.sortedColumn];
						return (fieldA > fieldB ? -1 : 1) * this.sortOrder;
					}
				});
			}
			return filteredData;
		},
		displayedData() {
			const start = (this.currentPage - 1) * this.itemsPerPage;
			const filteredData = this.filteredData.slice(
				start,
				start + this.itemsPerPage
			);
			return filteredData;
		},
		totalPages() {
			return Math.ceil(this.data.length / this.itemsPerPage);
		},
		showPagination() {
			return this.totalPages > 1;
		}
	},
	watch: {
		displayedData() {
			this.currentPage = this.currentPage <= 0 ? 1 : this.currentPage;
		}
	},
	methods: {
		sortTable() {
			this.sortOrder = this.sortOrder * -1;
			this.sortedColumn = null;
		},
		sortColumn(column) {
			this.sortedColumn = column;
			this.sortOrder = this.sortOrder * -1;
			this.isSorted = !this.isSorted;
		},
		changePage(pageNumber) {
			this.currentPage = pageNumber;
		},
		editRow(row) {
			this.$emit('editRow', row);
		},
		openDeleteModal(row) {
			this.titleDelete = row.facility;
			this.rowToDelete = row;
			this.showMessageDeletionModal = true;
		},
		setAllPage(page) {
			this.currentPage = page;
		},
		deleteFacility() {
			if (this.rowToDelete) {
				this.$emit('deleteRow', this.rowToDelete);
			}
			this.showMessageDeletionModal = false;
		},
		closeMessageDeletionModal() {
			this.showMessageDeletionModal = false;
		}
	}
};
</script>
<style lang="scss" scoped>
table {
	width: 100%;
	border-collapse: collapse;
	margin-top: 10px;
}
.td-input {
	padding: 0;
}
.th-question {
	&__email {
		width: 20%;
	}
	&__names {
		width: 15%;
	}
	&__facility {
		width: 20%;
	}
	&__role {
		width: 15%;
	}
	&__actions {
		width: 10%;
	}
}
.td-center {
	text-align: center;
	text-align: -webkit-center;
}
.container-evaluation-question {
	display: flex;
	flex-direction: column;
	gap: 20px;
}

.description-cell {
	max-width: 60px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.custom-input {
	display: flex;
	border-radius: 4px;
	border: 1px solid #ddd;
	box-shadow: inset 0 0 5px 0px rgba(0, 0, 0, 0.15);
	padding: 7px 5px;
	margin: 1px;
	gap: 5px;
}

.custom-input input {
	border: none;
	outline: none;
	width: 100%;
}
.custom-input:focus-within {
	outline: 2px solid $hover-state;
	box-shadow: inset 0 0 5px 0px rgba(0, 0, 0, 0.15);
}
.action-button {
	background-color: transparent;
	border: none;
	cursor: pointer;
	padding: 0 10px;
}
.th-sort {
	cursor: pointer;
	display: flex;
	justify-content: space-between;
}

th,
td {
	border: 1px solid #ddd;
	padding: 8px;
	text-align: left;
}

th {
	background-color: #ffff;
}
</style>
